import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatusIndicator = () => {
  const [systemStatus, setSystemStatus] = useState({
    database: 'operational',
    backup: 'operational',
    sync: 'operational',
    lastBackup: new Date(Date.now() - 3600000),
    lastSync: new Date(Date.now() - 300000),
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setSystemStatus(prev => ({
        ...prev,
        lastSync: new Date(),
      }));
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const getStatusColor = (status) => {
    const colorMap = {
      operational: 'var(--color-success)',
      warning: 'var(--color-warning)',
      error: 'var(--color-error)',
    };
    return colorMap?.[status] || 'var(--color-muted-foreground)';
  };

  const getStatusIcon = (status) => {
    const iconMap = {
      operational: 'CheckCircle',
      warning: 'AlertTriangle',
      error: 'XCircle',
    };
    return iconMap?.[status] || 'Circle';
  };

  const formatLastUpdate = (date) => {
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    return date?.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  };

  const statusItems = [
    { label: 'Database', status: systemStatus?.database, key: 'database' },
    { label: 'Backup', status: systemStatus?.backup, key: 'backup', lastUpdate: systemStatus?.lastBackup },
    { label: 'Sync', status: systemStatus?.sync, key: 'sync', lastUpdate: systemStatus?.lastSync },
  ];

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Activity" size={20} color="var(--color-accent)" />
        <h3 className="text-lg font-semibold text-foreground font-heading">System Status</h3>
      </div>
      <div className="space-y-3">
        {statusItems?.map((item) => (
          <div key={item?.key} className="flex items-center justify-between p-3 rounded-lg bg-input border border-border">
            <div className="flex items-center gap-3">
              <Icon 
                name={getStatusIcon(item?.status)} 
                size={18} 
                color={getStatusColor(item?.status)} 
              />
              <span className="text-sm font-medium text-foreground font-caption">{item?.label}</span>
            </div>
            <div className="text-right">
              <p className="text-xs font-medium font-caption" style={{ color: getStatusColor(item?.status) }}>
                {item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)}
              </p>
              {item?.lastUpdate && (
                <p className="text-xs text-muted-foreground font-caption">
                  {formatLastUpdate(item?.lastUpdate)}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-xs text-muted-foreground font-caption">
          <span>Last full check</span>
          <span>{new Date()?.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</span>
        </div>
      </div>
    </div>
  );
};

export default SystemStatusIndicator;